import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  dialogContent: {
    padding: 0,
  },
  dialogContentElement: {
    marginTop: 20,
  },
  actionsContainer: {
    marginTop: 24,
    padding: '8px 0 8px 0',
  },
  teamDialogPaper: {
    padding: 40,
  },
}));
